module.exports = __webpack_public_path__ + "static/media/seeds-of-change-desktop.f36d2619.jpg";